<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-single element-non-bodymatter element-type-toc toc-with-volume-author" epub:type="toc" id="table-of-contents" role="doc-toc">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-introduction has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/introduction"><span class="element-title-text">Introduction</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Jonathan Maberry</p>
<p class="element-title"><a href="#/vol001"><span class="element-title-text">Gavin Funke’s Monster Movie Marathon</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Luciano Marano</p>
<p class="element-title"><a href="#/vol002"><span class="element-title-text">Flickering Dusk of the Video God</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">David Gerrold</p>
<p class="element-title"><a href="#/vol003"><span class="element-title-text">Michael Thinks the House Is Haunted</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Jesse Sprague</p>
<p class="element-title"><a href="#/vol004"><span class="element-title-text">Atropos Green</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">C.H. Hung</p>
<p class="element-title"><a href="#/vol005"><span class="element-title-text">Last Sunset Home</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Kevin Pettway</p>
<p class="element-title"><a href="#/vol006"><span class="element-title-text">Love Your Mother</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">David Boop</p>
<p class="element-title"><a href="#/vol007"><span class="element-title-text">Progress Grows Out of Motion</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Julie Frost</p>
<p class="element-title"><a href="#/vol008"><span class="element-title-text">When the Shift Hits the Fan</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Shannon Fox</p>
<p class="element-title"><a href="#/vol009"><span class="element-title-text">Hyde Park</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Brendan Mallory</p>
<p class="element-title"><a href="#/vol010"><span class="element-title-text">Make Me a Star</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Linda Maye Adams</p>
<p class="element-title"><a href="#/vol011"><span class="element-title-text">Alien Pizza</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Sam Knight</p>
<p class="element-title"><a href="#/vol012"><span class="element-title-text">Whoever Writes Monsters</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Hailey Piper</p>
<p class="element-title"><a href="#/vol013"><span class="element-title-text">Toad Man, Toad Man</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Rick Wilber</p>
<p class="element-title"><a href="#/vol014"><span class="element-title-text">False Bay</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Steve Rasnic Tem</p>
<p class="element-title"><a href="#/vol015"><span class="element-title-text">Z Is for Zombie</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Ben Monroe</p>
<p class="element-title"><a href="#/vol016"><span class="element-title-text">Vinegar Syndrome</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Charles Maclay</p>
<p class="element-title"><a href="#/vol017"><span class="element-title-text">Beer with Friends</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Irene Radford</p>
<p class="element-title"><a href="#/vol018"><span class="element-title-text">Motivating A Monster</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">James A. Hearn</p>
<p class="element-title"><a href="#/vol019"><span class="element-title-text">Tunnel Visions</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Ryan F. Healey</p>
<p class="element-title"><a href="#/vol020"><span class="element-title-text">Our Lady of Celluloid</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Karina Fabian</p>
<p class="element-title"><a href="#/vol021"><span class="element-title-text">Josie’s Last Straw</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">B.D. Prince</p>
<p class="element-title"><a href="#/vol022"><span class="element-title-text">The Last Drive-in Movie</span></a></p>
</div>
</div>
<div class="toc-volume-group has-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="volume-author">Fran Wilde</p>
<p class="element-title"><a href="#/vol023"><span class="element-title-text">Welcome to the Underhill Cinema</span></a></p>
</div>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/additionalcopyrightinformation"><span class="element-title-text">Additional Copyright Information</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/abouttheeditor"><span class="element-title-text">About the Editor</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/ifyouliked"><span class="element-title-text">If You Liked …</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/otherwordfirepressanthologies"><span class="element-title-text">Other WordFire Press Anthologies</span></a></p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?709f8489